import Link from 'next/link';

interface HeadingSectionData {
	heading: {
		title: string
	}
	subheading: {
		title: string
	}
	button: {
		href: string
		label: string
	}
	button_back: {
		href: string
		label: string
	}
}

interface HeadingSectionProps {
  data: HeadingSectionData;
}

export const fields = [
	'heading.title',
	'subheading.title',
	// button
	'button.href',
	'button.label',

	// button_back
	'button_back.href',
	'button_back.label',

] as const

export default function HeadingSection({ data }: HeadingSectionProps) {
  if (!data) return null

	

  const replaceVariables = (text: string) => {
    return text.replace(/{{([\w.]+)}}/g, (match, path) => {
      const value = path
        .split(".")
        .reduce((obj: any, key: string) => obj?.[key], data);
      return value || match;
    });
  };

  if (data.heading?.title) {
    data.heading.title = replaceVariables(data.heading.title);
  }
  if (data.subheading?.title) {
    data.subheading.title = replaceVariables(data.subheading.title);
  }

  return (
		<>
			<section className='GalleryHeadingSection w-full bg-[#919985] py-12 md:py-16'>
				<div className='container text-white text-center grid gap-2'>
					{data.subheading?.title && <h1>{data.subheading?.title}</h1>}
					<p className='text-xl md:text-3xl uppercase tracking-wider'>
						{data.heading?.title}
					</p>
					<div className='flex justify-start gap-4'>
						{data?.button?.href && data?.button?.label && (
							<Link
								href={data.button?.href || '/'}
								className='w-full md:px-12 py-4 bg-brown-light rounded-lg hover:bg-brown text-neutral-50 transition-colors text-2xl font-brandon md:w-fit text-center'
								onClick={e => {
									if (data.button?.href) {
										e.preventDefault()
										window.location.href = data.button.href
									}
								}}
							>
								<span className='text-center text-neutral-50 text-2xl font-brandon leading-9'>
									{data.button.label}
								</span>
							</Link>
						)}
						{data?.button_back?.href && data?.button_back?.label && (
							<Link
								href={data.button_back?.href || '/gallery/'}
								className='w-full md:px-12 py-4 bg-none rounded-lg hover:bg-brown text-neutral-50 transition-colors text-2xl font-brandon md:w-fit text-center border border-white'
							>
								<span className='text-center text-neutral-50 text-2xl font-brandon leading-9'>
									{data.button_back.label}
								</span>
							</Link>
						)}
					</div>
				</div>
			</section>
		</>
	)
}
